import { createIntl, createIntlCache } from '@formatjs/intl';

import adminDashboardMessages from '@shieldpay/i18n/admin-dashboard/en-GB.json';
import loginMessages from '@shieldpay/i18n/login/en-GB.json';
import defaultMessages from '@shieldpay/i18n/shared/en-GB.json';

// This is optional but highly recommended
// since it prevents memory leak
const cache = createIntlCache();

// Merging all the messages together that will be used to create the intl object
export const messages = {
  ...defaultMessages,
  ...loginMessages,
  ...adminDashboardMessages,
};

// Creating the intl shape object that contains all the format* methods
export const intl = (locale = 'en-GB') =>
  createIntl(
    {
      locale,
      messages,
    },
    cache,
  );
